// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import gql from 'graphql-tag';

export const ORDERS_QUERY = gql`
  query OrdersHome(
      $status: String,
      $customer: String,
      $timeAfter: String,
      $timeBefore: String,
      $first: Int!,
      $after: String
    ) {
    orders(
      orderBy: [
        { name: "order.order_fulfillment_time", direction: "asc" }
        { name: "order.customer", direction: "asc" }
      ]
      filters: [
        { name: "order.order_status", operator: "in", value: $status }
        { name: "order.customer", operator: "in", value: $customer }
        { name: "order.order_fulfillment_time", operator: ">=", value: $timeAfter }
        { name: "order.order_fulfillment_time", operator: "<=", value: $timeBefore }
      ]
      first: $first
      after: $after
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          id
          order_status
          customer
          order_fulfillment_time
        }
      }
    }
  }
`;
